export enum ActionType {
    UPSERT_FILTER,
    STORE_FILTERED_MEDIA,
    REMOVE_FILTER,
    REMOVE_ALL_FILTERS,
    REQUEST_NEXT_BATCH,
    RECEIVE_NEXT_BATCH,
    REQUEST_FILTERS,
    RECEIVE_FILTERS,
    OPEN_MODAL,
    CLOSE_MODAL,
    SET_MODAL_CONTENT
};

export { IAction } from '../../../classes/action';


// WEBPACK FOOTER //
// ./app/media-gallery/redux/actions/actions.ts